<template>
  <v-container class="app">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" sm="12">
          <v-form ref="Deploy-decoy">
            Decoy Deployment. Don't forget to take photos!.
            <v-snackbar
              v-model="messageSnackbar"
              :timeout="messageTimeout"
              id="observation_message"
              color="red"
              variant="tonal"
            >
              <div class="text pb-2">{{ observationMessage }}</div>
            </v-snackbar>
            <v-col cols="12" md="12">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="record.id"
                    label="ID:"
                    :disabled="true"
                  ></v-text-field>
                  <v-tooltip location="top">
                    <template #activator="{ props }">
                      <v-btn
                        v-bind="props"
                        @click="setTime($event, 'ts')"
                        color="primary"
                        dark
                      >
                        Now</v-btn
                      >
                    </template>
                    Record time and coordinates
                  </v-tooltip>
                  <v-tooltip location="top">
                    <template #activator="{ props }">
                      <div v-bind="props">
                        <label class="datepicker-label">Deployed Time:</label>
                        <Datepicker
                          v-model="record.ts"
                          format="yyyy-MM-dd HH:mm"
                          :enable-time-picker="true"
                          placeholder="Deployed Time"
                          type="datetime"
                          clearable
                          menu-class="w-96"
                          :is-24="true"
                          teleport
                        />
                      </div>
                    </template>
                    Time when the decoy was placed?
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="record.actual_latitude_wgs84"
                    filled
                    label="Latitude:"
                    clearable
                    @input="submit"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="record.actual_longitude_wgs84"
                    filled
                    label="Longitude:"
                    clearable
                    @input="submit"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-tooltip location="top">
                    <template #activator="{ props }">
                      <v-combobox
                        v-bind="props"
                        v-model="record.decoy_id"
                        :items="refTables['ref_decoys']"
                        item-title="title"
                        item-value="code"
                        label="Decoy Id:"
                        :clearable="true"
                        :disabled="false"
                        :return-object="false"
                      ></v-combobox>
                    </template>
                    Select or enter a decoy_id
                  </v-tooltip>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="record.actual_cover_type"
                    label="Cover Type:"
                    :clearable="true"
                    :disabled="false"
                    :items="refTables['ref_cover_type']"
                    item-text="title"
                    item-value="code"
                    @input="submit"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="record.actual_strata"
                    label="Ground Cover:"
                    :clearable="true"
                    :disabled="false"
                    :items="refTables['ref_ground_cover']"
                    item-text="title"
                    item-value="code"
                    @input="submit"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="record.acual_light_distance_m"
                    label="Light Distance (m):"
                    inputmode="number"
                    :clearable="true"
                    :disabled="false"
                    @input="submit"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="record.comment"
                    filled
                    label="Comment:"
                    clearable
                    @input="submit"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-tooltip location="top">
                    <template #activator="{ props }">
                      <v-btn
                        v-bind="props"
                        @click="setRecoveredTime($event, 'recovered_ts')"
                        color="primary"
                        dark
                      >
                        Now</v-btn
                      >
                    </template>
                    Record recovered time
                  </v-tooltip>
                  <v-tooltip location="top">
                    <template #activator="{ props }">
                      <div v-bind="props">
                        <label class="datepicker-label">Recovered Time:</label>
                        <Datepicker
                          v-model="record.recovered_ts"
                          format="yyyy-MM-dd HH:mm"
                          :enable-time-picker="true"
                          placeholder="Recovered Time"
                          type="datetime"
                          clearable
                          menu-class="w-96"
                          :is-24="true"
                          teleport
                        />
                      </div>
                    </template>
                    Time when the decoy was recovered
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-form>
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import { support } from "search-observe-app";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
export default {
  name: "Decoy-Deploy-Form",
  components: { Datepicker },
  props: {
    photo_records: Array,
    selected_record: Object,
  },
  data() {
    return {
      handler: {
        submit: this.submit,
      },
      required: [(v) => !!v || "Required"],
      tableName: support.data.SURVEYSECONDARY,
      messageSnackbar: false,
      messageTimeout: 6000,
      record: this.selected_record,
    };
  },
  mounted() {
    this.$watch(
      "selected_record",
      () => {
        this.record = this.selected_record;
      },
      { deep: true }
    );
  },
  methods: {
    submit() {
      if (this.record.ts !== "" && this.record.ts !== undefined) {
        let records = support.forceFieldTypes(support.data.SURVEYPRIMARY, [
          this.record,
        ]);
        this.record.invalid = false;
        let key = `${
          this.$store.getters["shared/dbName"]
        }-${support.tableSpecificKey(support.data.SURVEYPRIMARY, records[0])}`;
        support.saveLocal(key, records[0]);
      } else {
        this.$store.commit("shared/setAttribute", {
          attribute: "observationMessage",
          value: "Deployment Time must be filled in",
        });
        this.record.invalid = true;
        this.messageSnackbar = true;
        //TODO make use of a generic popup to provide feedback that the record is invalid
      }
    },
    onDateTimeSet(value, parameter) {
      this.record[parameter] = support.getLocalTimestamp(new Date(value));
      this.submit();
    },
    setTime(value, parameter) {
      this.record[parameter] = support.getLocalTimestamp(new Date());
      this.record["actual_latitude_wgs84"] = support.getLatitude();
      this.record["actual_longitude_wgs84"] = support.getLongitude();
      this.submit();
    },
    setRecoveredTime(value, parameter) {
      this.record[parameter] = support.getLocalTimestamp(new Date());
      this.submit();
    },
  },

  computed: {
    observationMessage() {
      return this.$store.getters["shared/getAttribute"]("observationMessage");
    },
    refTables() {
      return this.$store.getters["shared/refTables"];
    },
  },
};
</script>
<style scoped>
::v-deep(.dp__input_wrap) {
  display: flex;
  align-items: center;
}

::v-deep(.dp__input) {
  padding-right: 2.5rem; /* give space for the icon */
  display: flex;
  align-items: center;
}

::v-deep(.dp__input_icon) {
  position: static !important; /* remove absolute positioning */
  margin-left: 0.5rem;
  width: 16px;
  height: 16px;
}
.datepicker-label {
  font-size: 0.75rem; /* ~text-xs */
  color: #9ca3af; /* Tailwind's gray-400 */
  display: block;
  margin-bottom: 0.25rem;
}
::v-deep(.dp__menu) {
  width: auto;
  min-width: 300px;
  max-width: 100%;
}
</style>
